import { Navigate, Route, Routes } from "react-router-dom";
import { BoAuthProvider, useBo } from "./AdminAuth";
import { AdminLogin, AcceptInvite } from "./Login";
import Layout, { NAV } from "./Layout";
import Dashboard from "./pages/Dashboard";
import { Clients, ClientProfile } from "./pages/Clients";
import { Funds, Orders, OrderDetail, Positions, Holdings, Trades, Gtt } from "./pages/Trading";
import { Risk, Surveillance, LiveMonitor } from "./pages/Risk";
import { Instruments, Calendar, CorporateActions, Brokerage, TradingSettings } from "./pages/Ops";
import { Notifications, Reports, Notes, Approvals, AdminUsers, Audit, Health, Settings } from "./pages/Admin";
import { Spinner } from "./ui";

const PAGES = {
  clients: Clients, funds: Funds, orders: Orders, positions: Positions, holdings: Holdings, trades: Trades, gtt: Gtt, risk: Risk,
  surveillance: Surveillance, monitor: LiveMonitor, instruments: Instruments, calendar: Calendar, "corporate-actions": CorporateActions,
  brokerage: Brokerage, "trading-settings": TradingSettings, notifications: Notifications, reports: Reports, notes: Notes,
  approvals: Approvals, audit: Audit, admins: AdminUsers, health: Health, settings: Settings,
};

function NoAccess() {
  return <div data-testid="no-access" className="mt-20 text-center text-sm text-muted-foreground">Your role does not have access to this page.</div>;
}

function Gate() {
  const { admin, can } = useBo();
  if (admin === null) return <div className="dark flex h-screen items-center justify-center bg-background"><Spinner /></div>;
  if (!admin) return <AdminLogin />;
  const perm = (path) => (NAV.find(([, p]) => p === path) || [])[3];
  const guard = (path, El) => (can(perm(path)) ? <El /> : <NoAccess />);
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={can("dash.view") ? <Dashboard /> : <NoAccess />} />
        {Object.entries(PAGES).map(([path, El]) => <Route key={path} path={path} element={guard(path, El)} />)}
        <Route path="clients/:id" element={guard("clients", ClientProfile)} />
        <Route path="orders/:id" element={guard("orders", OrderDetail)} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}

export default function AdminApp() {
  return (
    <BoAuthProvider>
      <Routes>
        <Route path="invite" element={<AcceptInvite />} />
        <Route path="*" element={<Gate />} />
      </Routes>
    </BoAuthProvider>
  );
}
